{
  "ForgotPassword": "¿Olvidaste tu contraseña?",
  "EmailAddress": "Dirección de correo electrónico",
  "SendInstructions": "Envíame instrucciones >",
  "Login": "Iniciar sesión",
  "or": "o",
  "Signup": "Regístrate",
  "instead": "en lugar",
  "ResetPassword": "Restablecer la contraseña"
}
